var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-alert',{attrs:{"show":"","variant":"warning"}},[_c('h6',[_vm._v("Invalid Action, please contact your Administrator")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }